import { PrimaryRegularButton } from 'components/ReusableComponents/Button/RegularButtons'
import { formatPrice } from 'utils/common'

import styles from './RoomRow.module.scss'

const SavibookRoomRow = ({
  name,
  description,
  nightlyPrice,
  baseurl,
  onSelectRoom,
  isPostPay
}) => {
  return (
    <div to={`${baseurl}/book/payment`} className={styles.room}>
      <div className={styles.info}>
        <p className={styles.roomName}>{name}</p>
        <p className={styles.roomDescription}>{description}</p>
        {isPostPay && <p className={styles.postPayText}>Book now, pay later</p>}
      </div>
      <div className={styles.featuredBottomBar}>
        <div className={styles.priceHolder}>
          <p className={styles.price}>{formatPrice(nightlyPrice)}</p>
          <p className={styles.priceDescription}>/ night</p>
        </div>
        <PrimaryRegularButton className={styles.bookButton} onClick={onSelectRoom}>
          Copy link
        </PrimaryRegularButton>
      </div>
    </div>
  )
}

export default SavibookRoomRow
